<template>
  <el-row>
    <el-col :span="5">
      <div style="overflow-y: scroll;">
        <div id="leftTreeId" style="height: 775px;">
          <basic-container>
            <el-input placeholder="输入关键字进行过滤" v-model="filterText"> </el-input>
            <el-tree
              class="filter-tree"
              accordion
              :props="treeProps"
              node-key="id"
              ref="leftTreeRef"
              :load="lazyLoadLeftTree"
              :filter-node-method="filterNode"
              lazy
              @node-click="nodeClick"
            >
            </el-tree>
          </basic-container>
        </div>
      </div>
    </el-col>
    <el-col :span="19">
      <!-- :visible.sync="propertyEditShowDialogFlag" -->
      <basic-container id="mainContainerId">
        <div class="el-property-dialog-div">
          <avue-form
            ref="propertyEditFormRef"
            v-model="propertyEditForm"
            :option="propertyEditOption"
            @reset-change="propertyEditReset"
            @submit="propertyEditSubmit"
          >
          </avue-form>
        </div>
      </basic-container>
    </el-col>
  </el-row>
</template>

<script>
import {
  add,
  addNode,
  addProperty,
  getDetail,
  getDetailById,
  getList,
  getRoomInfo,
  getTreeChildrenNode,
  removeNode,
  removeProperty,
  update,
  updateNode,
  updateProperty,
} from '@/api/v4ward/property/baseproperty';
import { mapGetters } from 'vuex';
import treeOption from './tree-option';
import propertyAddOption from './property-add-option';
import propertyOption from './property-option';
import propertyEditOption from './property-change-option.js';
import nodeAddOption from './node-add-option';
import nodeEditOption from './node-edit-option';
import propertyViewOption from './property-view-option';
import { getOneDepartmentDetail } from '@/api/v4ward/department/department';

export default {
  data() {
    return {
      treeProps: {
        //标题
        label: 'title',
        //值
        value: 'id',
        //子节点
        children: 'zones',
        //是否叶子节点
        isLeaf: 'isLeaf',
        //本节点类型key值
        objectType: 'objectType',
        //本节点类型名
        objectTypeName: 'objectTypeName',
        //节点数据权限
        dataPower: 'dataPower',
      },
      leftTreeRoot: {},
      leftTreeResolve: {},

      isNodeAddDialogFirstOpen: true,
      nodeAddParentNodeTreeRoot: {},
      nodeAddParentNodeTreeResolve: {},
      isPropertyAddDialogFirstOpen: true,
      propertyAddParentNodeTreeRoot: {},
      propertyAddParentNodeTreeResolve: {},

      //选中的树形节点信息
      treeTrackId: '',
      filterText: '',

      //选中的表格行信息
      tableTrackId: '',

      //父节点树结构相关信息
      parentId: '',
      parentObjectName: '',
      parentObjectType: 0,
      parentObjectTypeName: '',

      //form表单数据
      form: {},
      propertyEditForm: {},

      query: {},
      loading: true,

      treeOption: treeOption,
      nodeAddOption: nodeAddOption,
      nodeEditOption: nodeEditOption,
      propertyOption: propertyOption,
      propertyAddOption: propertyAddOption,
      propertyEditOption: propertyEditOption,
      propertyViewOption: propertyViewOption,

      //页面数据
      treeData: [],
      data: [],

      //数据权限
      DATA_POWER_NULL: 0,
      DATA_POWER_VIEW: 1,
      DATA_POWER_VIEW_EDIT: 2,
      DATA_POWER_VIEW_EDIT_DEL: 3,
      tableUseType: '',
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.baseproperty_add, false),
        viewBtn: this.vaildData(this.permission.baseproperty_view, false),
        delBtn: this.vaildData(this.permission.baseproperty_delete, false),
        editBtn: this.vaildData(this.permission.baseproperty_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created() {
    this.propertyEditOption.submitSize = 'medium';
    this.propertyEditOption.submitText = '修改';
  },
  mounted() {},
  watch: {
    filterText(val) {
      this.$refs.leftTreeRef.filter(val);
    },
    'propertyAddForm.useType'() {
      if (this.propertyAddForm.useType === 4) {
        this.propertyAddOption.group[1].display = false;
        this.propertyAddOption.group[2].display = true;
        this.propertyAddForm.householdName = '公寓物业';
        this.propertyAddForm.householdLinkPhone = '123456';
      } else {
        this.propertyAddOption.group[1].display = true;
        this.propertyAddOption.group[2].display = false;
        this.propertyAddForm.householdName = '';
        this.propertyAddForm.householdLinkPhone = '';
      }
    },
    'propertyEditForm.useType'() {
      if (this.propertyEditForm.useType === 4) {
        this.propertyEditOption.group[1].display = false;
        this.propertyEditOption.group[2].display = true;
        this.propertyEditForm.householdName = '公寓物业';
        this.propertyEditForm.householdLinkPhone = '123456';
      } else {
        this.propertyEditOption.group[1].display = true;
        this.propertyEditOption.group[2].display = false;
      }
    },
    'propertyViewForm.useType'() {
      if (this.propertyViewForm.useType === 4) {
        this.propertyViewOption.group[1].display = false;
        this.propertyViewOption.group[2].display = true;
      } else {
        this.propertyViewOption.group[1].display = true;
        this.propertyViewOption.group[2].display = false;
      }
    },
  },
  methods: {
    //懒加载树结构
    lazyLoadLeftTree(node, resolve) {
      let id;
      if (node.level === 0) {
        id = 0;
        this.leftTreeRoot = node;
        this.leftTreeResolve = resolve;
      } else {
        id = node.data.id;
      }

      getTreeChildrenNode({ id: id }).then(({ data }) => {
        resolve(data);
      });
    },
    lazyLoadNodeAddParentNodeTree(node, resolve) {
      let id;
      if (node.level === 0) {
        id = 0;
        this.nodeAddParentNodeTreeRoot = node;
        this.nodeAddParentNodeTreeResolve = resolve;
      } else {
        id = node.data.id;
      }

      getTreeChildrenNode({ id: id }).then(({ data }) => {
        resolve(data);
      });
    },
    lazyLoadPropertyAddParentNodeTree(node, resolve) {
      let id;
      if (node.level === 0) {
        id = 0;
        this.propertyAddParentNodeTreeRoot = node;
        this.propertyAddParentNodeTreeResolve = resolve;
      } else {
        id = node.data.id;
      }

      getTreeChildrenNode({ id: id }).then(({ data }) => {
        resolve(data);
      });
    },
    //重新加载左侧树结构
    reloadLeftTree() {
      this.leftTreeRoot.childNodes = [];
      this.lazyLoadLeftTree(this.leftTreeRoot, this.leftTreeResolve);
    },
    reloadNodeAddParentNodeTree() {
      this.nodeAddParentNodeTreeRoot.childNodes = [];
      this.lazyLoadNodeAddParentNodeTree(
        this.nodeAddParentNodeTreeRoot,
        this.nodeAddParentNodeTreeResolve
      );
    },
    reloadPropertyAddParentNodeTree() {
      this.propertyAddParentNodeTreeRoot.childNodes = [];
      this.lazyLoadPropertyAddParentNodeTree(
        this.propertyAddParentNodeTreeRoot,
        this.propertyAddParentNodeTreeResolve
      );
    },
    //树节点过滤
    filterNode(value, data) {
      if (!value) return true;
      return data[this.treeProps.label].indexOf(value) !== -1;
    },

    //点击左侧树结构回调
    nodeClick(data) {
      if (data.objectType == 6) {
        this.treeTrackId = data.id;
        this.showDetails();
      }
    },
    showDetails() {
      this.loading = true;
      getList(
        Object.assign({ current: 1, size: 1, treeTrackId: this.treeTrackId }, this.query)
      ).then(({ data }) => {
        // this.data = data.records;
        this.propertyEditForm = data.records[0];
        if (this.propertyEditForm.useType === 4) {
          getOneDepartmentDetail({ propertyId: this.propertyEditForm.id }).then((res) => {
            this.propertyEditForm.bedCapacity = res.data[0].bedCapacity;
            this.propertyEditForm.bedUsing = res.data[0].bedUsing;
            // this.tableUseType = '';
          });
        }else {
          this.propertyEditForm.bedUsing = 0;
        }
        this.loading = false;
      });
    },

    // 初始化父节点树结构
    initNodeAddParentNodeTree() {
      this.initSelectTreeStyle();
      if (!this.isNodeAddDialogFirstOpen) {
        this.reloadNodeAddParentNodeTree();
      } else {
        this.isNodeAddDialogFirstOpen = false;
      }
    },
    initPropertyAddParentNodeTree() {
      this.initSelectTreeStyle();
      if (!this.isPropertyAddDialogFirstOpen) {
        this.reloadPropertyAddParentNodeTree();
      } else {
        this.isPropertyAddDialogFirstOpen = false;
      }
    },
    initSelectTreeStyle() {
      this.$nextTick(() => {
        let scrollWrap = document.querySelectorAll('.el-scrollbar .el-select-dropdown__wrap')[0];
        let scrollBar = document.querySelectorAll('.el-scrollbar .el-scrollbar__bar');
        scrollWrap.style.cssText = 'margin: 0px; max-height: none; overflow: hidden;';
        scrollBar.forEach((ele) => (ele.style.width = 0));
      });
    },

    //重置窗口数据
    propertyEditReset() {
      this.propertyEditForm.id = this.tableTrackId;
      this.propertyEditForm.parentId = this.parentId;
      this.propertyEditForm.parentObjectName = this.parentObjectName;
      this.propertyEditForm.parentObjectTypeName = this.parentObjectTypeName;
    },

    // 清除父节点树选项
    nodeAddClearParentNodeSelect() {
      this.parentObjectName = '';
      this.parentObjectTypeName = '';
      this.nodeAddForm.parentObjectTypeName = '';
      this.clearTreeStyle(this.nodeAddShowDialogFlag, 'nodeAddParentNodeTree');
      this.$emit('getValue', null);
    },
    clearTreeStyle(showDialogFlag, treeId) {
      if (showDialogFlag) {
        let allNode = document.querySelectorAll('#' + treeId + ' .el-tree-node');
        allNode.forEach((element) => element.classList.remove('is-current'));
      }
    },
    propertyEditSubmit(form, done) {
      this.$refs.propertyEditFormRef.validate((valid) => {
        if (valid) {
          if (this.vdui.isEmpty(form.parentId)) {
            form.parentId = '0';
          }
          updateProperty(form).then(
            () => {
              this.reloadLeftTree();
              this.$message.success('操作成功!');
              this.propertyEditShowDialogFlag = false;
              this.$refs.propertyEditFormRef.resetForm();
              this.bedCapacity = 0;
              this.bedUsing = 0;
              this.editIsShow = false;
              done();
            },
            (error) => {
              done();
              console.log(error);
            }
          );
        }
      });
    },
    nodeEditDialog() {
      this.nodeEditShowDialogFlag = false;
      this.$refs.nodeEditFormRef.resetForm();
    },

    propertyEditDialog() {
      this.propertyEditShowDialogFlag = false;
      this.$refs.propertyEditFormRef.resetForm();
    },
  },
};
</script>

<style scoped>
.el-scrollbar .el-scrollbar__view .el-select-dropdown__item {
  height: auto;
  max-height: 274px;
  padding: 0;
  overflow: hidden;
  overflow-y: auto;
}
.el-select-dropdown__item.selected {
  font-weight: normal;
}
ul li >>> .el-tree .el-tree-node__content {
  height: auto;
  padding: 0 20px;
}
.el-tree-node__label {
  font-weight: normal;
}
.el-tree >>> .is-current .el-tree-node__label {
  color: #409eff;
  font-weight: 700;
}
.el-tree >>> .is-current .el-tree-node__children .el-tree-node__label {
  color: #606266;
  font-weight: normal;
}

.el-node-dialog-div {
  height: 500px;
  overflow: auto;
}

.el-property-dialog-div {
  height: inherit;
  overflow: auto;
}
</style>
